import { Box, Stack, Skeleton } from '@ltvco/refresh-lib/theme';

export const CardSkeleton = () => {
  return (
    <Box sx={{ mt: 2, mb: 2 }}>
      <Stack spacing={2}>
        <Stack spacing={1.5}>
          <Skeleton variant="rounded" height={20} width="100%" />
          <Skeleton variant="rounded" height={20} width="95%" />
          <Skeleton variant="rounded" height={20} width="98%" />
        </Stack>

        <Box sx={{ mt: 2 }}>
          <Skeleton variant="rounded" height={36} width={150} />
        </Box>
      </Stack>
    </Box>
  );
};
